export enum DevelopmentTabEnum {
    Development = "developing-the-tool",
    ConsiderationsLimitations = "considerations-limitations",
    CollaboratorsPublications = "collaborators-publications"
}
